export const SET_ACTIVE_ITEM = 'SET_ACTIVE_ITEM'
export const DO_SET_ACTIVE_ITEM = 'DO_SET_ACTIVE_ITEM'